import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = {
  key: 0,
  class: "modal-content bg-dark text-light"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = ["data-bs-target"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left cursor-pointer" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-title" }
const _hoisted_9 = ["id"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "table table-dark table-borderless d-flex" }
const _hoisted_14 = {
  key: 1,
  class: "d-flex flex-wrap cursor-pointer"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "mt-2" }
const _hoisted_18 = ["data-bs-target", "onClick"]
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullSizeGalleryModal = _resolveComponent("FullSizeGalleryModal")!
  const _component_ArtistModal = _resolveComponent("ArtistModal")!
  const _component_LocationModal = _resolveComponent("LocationModal")!
  const _component_NextEvents = _resolveComponent("NextEvents")!
  const _component_ModalImagesGallery = _resolveComponent("ModalImagesGallery")!
  const _component_Gallery = _resolveComponent("Gallery")!
  const _component_ModalLocationGallery = _resolveComponent("ModalLocationGallery")!
  const _component_ModalContacts = _resolveComponent("ModalContacts")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.event)
      ? (_openBlock(), _createBlock(_component_FullSizeGalleryModal, {
          key: 0,
          imgs: _ctx.event.galleryImages,
          img: _ctx.currImg,
          id: _ctx.id+'ImageGallery',
          "parent-modal": _ctx.id
        }, null, 8, ["imgs", "img", "id", "parent-modal"]))
      : _createCommentVNode("", true),
    (_ctx.updateCount !== 0)
      ? (_openBlock(), _createBlock(_component_ArtistModal, {
          artist: _ctx.currArtist,
          id: _ctx.id + 'ArtistModal',
          "parent-modal": _ctx.id,
          key: _ctx.updateCount
        }, null, 8, ["artist", "id", "parent-modal"]))
      : _createCommentVNode("", true),
    (_ctx.updateCount !== 0)
      ? (_openBlock(), _createBlock(_component_LocationModal, {
          location: _ctx.currLocation,
          id: _ctx.id + 'LocationGallery',
          "parent-modal": _ctx.id,
          key: _ctx.updateCount
        }, null, 8, ["location", "id", "parent-modal"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.id,
      tabindex: "-1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.event)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.parentModal)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "clean-btn me-4",
                      "data-bs-toggle": "modal",
                      "data-bs-target": '#' + _ctx.parentModal,
                      "data-bs-dismiss": "modal"
                    }, _hoisted_7, 8, _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.event.name), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  id: _ctx.id+'Close'
                }, null, 8, _hoisted_9)
              ]),
              (_ctx.event.headerImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.event.headerImage,
                    class: "modal-header-image"
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  innerHTML: _ctx.event.description
                }, null, 8, _hoisted_12),
                (_ctx.event.tickets && _ctx.event.tickets.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t( 'event.price' )), 1),
                      _createElementVNode("table", _hoisted_13, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.tickets, (ticket) => {
                            return (_openBlock(), _createElementBlock("tr", { key: ticket }, [
                              _createElementVNode("td", null, _toDisplayString(ticket.name), 1),
                              _createElementVNode("td", null, _toDisplayString(ticket.price), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                ((_ctx.event.categories && _ctx.event.categories.length > 0) || (_ctx.event.virtualCategories && _ctx.event.virtualCategories.length > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.categories, (category) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "badge bg-light text-dark me-2 mt-2",
                          key: category.id,
                          onClick: ($event: any) => (_ctx.searchForCategory(category.id))
                        }, _toDisplayString(_ctx.$t( 'category.' + category.slug )), 9, _hoisted_15))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.virtualCategories, (category) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "badge bg-light text-dark me-2 mt-2",
                          key: category,
                          onClick: ($event: any) => (_ctx.searchForVirtualCategory(category))
                        }, _toDisplayString(_ctx.$t( 'category.' + category )), 9, _hoisted_16))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_NextEvents, { event: _ctx.event }, null, 8, ["event"]),
                (_openBlock(), _createBlock(_component_ModalImagesGallery, {
                  id: _ctx.id+'ImageGallery',
                  galleryImages: _ctx.event.galleryImages,
                  key: _ctx.updateCount,
                  onChange: _ctx.setCurrImage
                }, null, 8, ["id", "galleryImages", "onChange"])),
                (_ctx.event.performers && _ctx.event.performers.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.$t( 'event.performer' )), 1),
                      (_openBlock(), _createBlock(_component_Gallery, {
                        "single-line": true,
                        id: _ctx.id+'PerformerGallery',
                        "no-grid": true,
                        key: _ctx.updateCount
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.performers, (artist) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: artist,
                              class: "img-with-bottom-title d-inline-block me-2"
                            }, [
                              _createElementVNode("button", {
                                "data-bs-toggle": "modal",
                                class: "clean-btn",
                                "data-bs-target": '#' + _ctx.id + 'ArtistModal',
                                onClick: ($event: any) => (_ctx.setArtist(artist.id))
                              }, [
                                _createElementVNode("img", {
                                  src: artist.thumbImage,
                                  class: "img-thumbnail img-cover"
                                }, null, 8, _hoisted_19)
                              ], 8, _hoisted_18),
                              _createElementVNode("span", null, _toDisplayString(artist.title), 1)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["id"]))
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_ModalLocationGallery, {
                  id: _ctx.id+'LocationGallery',
                  locations: _ctx.event.locations,
                  onChange: _ctx.setLocation
                }, null, 8, ["id", "locations", "onChange"]),
                _createVNode(_component_ModalContacts, {
                  contacts: _ctx.event.contacts
                }, null, 8, ["contacts"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_1)
  ], 64))
}